import { useEffect, useState } from "react"
import { config } from "../config"
import { Opco } from "../models"
import { setLocalStorageAndTriggerEvent } from "../utils"
;(window as any).plantyn = () => {
  setLocalStorageAndTriggerEvent(config.selectedOpcoLocalstorageKey, `${Opco.Plantyn}`)
}
;(window as any).noordhoff = () => {
  setLocalStorageAndTriggerEvent(config.selectedOpcoLocalstorageKey, `${Opco.Noordhoff}`)
}
;(window as any).liber = () => {
  setLocalStorageAndTriggerEvent(config.selectedOpcoLocalstorageKey, `${Opco.Liber}`)
}

export function useOpco(): Opco {
  const [opco, setOpco] = useState<Opco>(Opco.Noordhoff)

  useEffect(() => {
    window.addEventListener("storage", onStorageChanged)

    const value: string | null = localStorage.getItem(config.selectedOpcoLocalstorageKey)

    const opco: Opco = value !== null ? +value : Opco.Noordhoff
    setOpco(opco)

    return () => {
      window.removeEventListener("storage", onStorageChanged)
    }
  }, [])

  function onStorageChanged(event: StorageEvent): void {
    if (event.key === config.selectedOpcoLocalstorageKey) {
      const value: Opco = +event.newValue!
      setOpco(value)
    }
  }

  return opco
}
